module.exports = __webpack_public_path__ + "img/samuel_rosado_zaidi.355014a6.jpeg";